// import ChangesMonitor from 'src/constrains/SalesChannelContent-Revamp/HomePageChangesMonitor';
import ContentGrid from '@/src/components/SalesChannelComponents/SalesChannelContentGrid';
import { get } from 'lodash';
import { useProfile } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/hooks/useProfile';
import Wrapper from 'src/constrains/SalesChannelContentWrapperRevamp';
import React from 'react';
import { Form } from '@/src/components/RcForm';
import Visible from '@/src/components/Modules-revamp/Visible';
import { EPreviewSize } from '@/src/types/common/SalesChannel';

import FeatureProduct from 'src/pages/SalesChannelContentEditor/Components/FeatureProducts-revamp';
import BackgroundStyle from './BackgroundStyle';
import Policy from './Policy';
import ProfileContentManagement from './ProfileContentManagement';
import ChangesMonitor from 'src/pages/SalesChannelContentEditor/Components/ChangeMonitor';
import { getI18nFromGeneral } from 'src/tools/tools';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { useSelector } from 'react-redux';
import { isPrimaryLanguage } from '@/src/constrains/SalesChannelMultiLanguageSelect/slice';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';

const ProfilePage = () => {
  const {
    salesChannel,
    hasModified,
    onGoBack,
    pcForm,
    mobileForm,
    tabletForm,
    loaded,
    setHasModified,
    handleFieldsChange,
    handleOnSubmit,
    handleOnDiscard,
    handleOnReset,
    handleOnCopy,
    data,
  } = useProfile();
  const isPrimary = useSelector(isPrimaryLanguage());
  const headerProps = {
    title: get(salesChannel, 'name'),
    description: get(data, 'salesChannelContent.versionName'),
    status: get(data, 'salesChannelContent.status'),
    hasModified,
    onSubmit: handleOnSubmit,
    onDiscard: handleOnDiscard,
    onGoBack,
  };
  const commonProps = {
    handleOnSectionReset: handleOnReset,
    handleOnSectionCopy: handleOnCopy,
  };

  const WrappedProfileContent = SalesChannelModeAccessControlHOC(() => {
    return (
      <ContentGrid
        configCols={[
          {
            child: (
              <Form form={pcForm} onFieldsChange={handleFieldsChange}>
                <Visible alwaysVisible breakpoint={EPreviewSize.WIDE} />
                <BackgroundStyle
                  breakpoint={EPreviewSize.WIDE}
                  isPrimary={isPrimary}
                />
                <Policy breakpoint={EPreviewSize.WIDE} />
                {isPrimary && (
                  <>
                    <ProfileContentManagement breakpoint={EPreviewSize.WIDE} />
                    <FeatureProduct breakpoint={EPreviewSize.WIDE} />
                  </>
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={tabletForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.TABLET} />
                <BackgroundStyle
                  breakpoint={EPreviewSize.TABLET}
                  isPrimary={isPrimary}
                  {...commonProps}
                />
                <Policy breakpoint={EPreviewSize.TABLET} disabled />
                {isPrimary && (
                  <>
                    <ProfileContentManagement
                      breakpoint={EPreviewSize.TABLET}
                      {...commonProps}
                    />
                    <FeatureProduct
                      // handleOnSectionReset={handleOnReset}
                      breakpoint={EPreviewSize.TABLET}
                      disabled
                    />
                  </>
                )}
              </Form>
            ),
          },
          {
            child: (
              <Form form={mobileForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.MOBILE} />
                <BackgroundStyle
                  breakpoint={EPreviewSize.MOBILE}
                  isPrimary={isPrimary}
                  {...commonProps}
                />
                <Policy breakpoint={EPreviewSize.MOBILE} disabled />
                {isPrimary && (
                  <>
                    <ProfileContentManagement
                      breakpoint={EPreviewSize.MOBILE}
                      {...commonProps}
                    />
                    <FeatureProduct
                      // handleOnSectionReset={handleOnReset}
                      breakpoint={EPreviewSize.MOBILE}
                      disabled
                    />
                  </>
                )}
              </Form>
            ),
          },
        ]}
        mainCol={null}
      />
    );
  });

  return (
    <Wrapper headerProps={headerProps}>
      <ChangesMonitor
        loaded={loaded}
        setHasModified={setHasModified}
        pcForm={pcForm}
        tabletForm={tabletForm}
        mobileForm={mobileForm}
      />
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <WrappedProfileContent />
    </Wrapper>
  );
};
export default ProfilePage;
